/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { useCallback, useState } from 'react';
// material
import {
  Button
} from '@insticator/insticator-ui'; // iui-material
import ActionButtons from 'material/expandablesection/actionbuttons';
// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/controllers/configcontroller/configcontroller_styles';


const ConfigController = (props) => {
  const {
    title,
    description,
    handleCancel,
    handleSave,
    disableSave,
    isOpened,
    setIsOpened,
    processing
  } = props;

  return (
    <div className={`configcontroller ${props.classes.configcontroller} ${props.className} header controls`}>
      <h2 className='title'>
        {title}
      </h2>
      {!isOpened && <div className={'description'}>
        {description}
      </div>}
      <div>
        {isOpened ?
            <ActionButtons handleSave={handleSave} disableSave={disableSave} isOpened={isOpened} processing={processing} setIsOpened={setIsOpened} handleCancel={handleCancel} /> :
          <Button
            variant={'system'}
            text={'Configure'}
            type={'action'}
            action={() => setIsOpened(true)}
          />
        }
      </div>
    </div>
  )
};

export default injectSheet(styles)(ConfigController)
